import styled from '@src/styled-components';
import React from 'react';

interface IFormflowLateralTitlePropType {
    titleText: string;
};

interface IFormflowLateralTitleStateType { };


export default class FormflowLateralTitle extends React.Component<IFormflowLateralTitlePropType, IFormflowLateralTitleStateType> {

    constructor(props: IFormflowLateralTitlePropType) {
        super(props);
        this.state = {

        };
    }

    render() {
        const {
        } = this.props;

        return (
            <Wrapper>
                <h3 className="title">{this.props.titleText}</h3>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`

    .title{
        font-weight:bold;
    }
    
`


